import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-12 md:py-16 bg-secondary-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="relative rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20glowing%20circles%20and%20flowing%20shapes%2C%20modern%20media%20and%20entertainment%20concept%2C%20warm%20orange%20and%20coral%20tones%2C%20minimalist%20design%2C%20elegant%20composition%2C%20dreamlike%20atmosphere&width=1280&height=400&seq=cta-bg-2026&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-secondary-900/70"></div>

          <div className="relative z-10 py-12 md:py-16 px-6 md:px-12 text-center">
            <h2 className="text-xl md:text-2xl font-bold text-background-50 font-heading mb-3">
              还没找到喜欢的视频？
            </h2>
            <p className="text-sm text-background-200 max-w-md mx-auto mb-6">
              浏览全部精选福利视频，发现更多精彩内容。每日更新，持续不断，总有新的惊喜等着你。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-grid-line mr-1.5"></i>
                浏览全部视频
              </Link>
              <Link
                to="/about"
                className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line mr-1.5"></i>
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}